// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xupgP","navItem":"styles_navItem__52ZXz","link":"styles_link__s7CEw","active":"styles_active__-4uq0"};